'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.weeksAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/weeksAgo.js
// module id = 390
// module chunks = 1